import { useEffect } from 'react';

export function useDialogKeyboard(open, { onEnter, onEscape, disabled = false } = {}) {
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (e.key === 'Enter' && onEnter && !disabled) { e.preventDefault(); onEnter(); }
      if (e.key === 'Escape' && onEscape && !disabled) { e.preventDefault(); onEscape(); }
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [open, onEnter, onEscape, disabled]);
}
